import { css } from '@emotion/react';
import { type FC } from 'react';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import type { EntityAccessInvitation } from '~/_shared/entityAccess/entityAccess.invitations.repository';
import type { EntityAccess } from '~/_shared/entityAccess/entityAccess.repository';
import { useTheme } from '~/_shared/themes/theme.hooks';
import { type ThemeProps } from '~/_shared/types/themeProps';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  TableComponent, TableHeaderCellComponent, TableHeaderComponent,
} from '~/map/mapMigration/table';
import { type TeamShareMapPermission } from '../teamShareMap.types';
import { type MapAccessData } from '../teamShareMapModal.container';
import { MembersTableItem } from './membersTableItem.component';

const columnWidths = ['35px', 'auto', 'auto', '170px', '30px'];

const tableContainerStyle = css({
  padding: '0 22px 45px 22px',
});

const loaderStyle = ({ theme }: ThemeProps) => css({
  background: theme.loadingOverlay.backgroundColor,
});

type MembersTableComponentProps = {
  currentUserId: number | null;
  isLoading: boolean;
  mapAccessData: MapAccessData[];

  onUpdateAccess: (item: EntityAccess, newPermission: TeamShareMapPermission) => void;
  onDeleteAccess: (item: EntityAccess) => void;
  onDeleteInvitation: (item: EntityAccessInvitation) => void;
};

export const MembersTableComponent: FC<MembersTableComponentProps> = (props) => {
  const { currentUserId, isLoading, mapAccessData, ...handlers } = props;
  const [t] = useTranslation();
  const theme = useTheme();

  return (
    <div css={tableContainerStyle}>
      {isLoading && (
        <OverlayLoaderComponent
          css={loaderStyle({ theme })}
          loaderSize={45}
        />
      )}
      <TableComponent columnWidths={columnWidths}>
        <TableHeaderComponent>
          <TableHeaderCellComponent
            colSpan={2}
            css={{ textAlign: 'left' }}
          >
            {t('Team Member')}
          </TableHeaderCellComponent>
          <TableHeaderCellComponent>
            {t('Email')}
          </TableHeaderCellComponent>
          <TableHeaderCellComponent
            colSpan={2}
            css={{ textAlign: 'left' }}
          >
            {t('Permissions Level')}
          </TableHeaderCellComponent>
        </TableHeaderComponent>

        {currentUserId && mapAccessData.map((item, idx) => (
          <MembersTableItem
            key={idx}
            index={idx + 1}
            item={item}
            currentUserId={currentUserId}
            {...handlers}
          />
        ))}
      </TableComponent>
    </div>
  );
};
